import React from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { customStyle, customStyles } from "./css.hook";

interface MultiSelectProps {
  name: string;
  control: any;
  options: { label: string; value: string }[];
  allDataLength: number;
  isAllDisabled?: boolean;
  label: string;
  required?: boolean;
  placeholder?: string;
}

const MultiSelectWithSelectAll: React.FC<MultiSelectProps> = ({
  name,
  control,
  options,
  allDataLength,
  isAllDisabled = false,
  label,
  required = false,
  placeholder = "--Select--",
}) => {
  const selectAllOption = { label: "Select All", value: "*" };
  const modifiedOptions = [selectAllOption, ...options];

  return (
    <div className="col-md-4 mt-3">
      <label className="form-label">
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </label>

      <Controller
        name={name}
        control={control}
        // rules={{
        //   validate: (value) => {
        //     if (!value || value.length === 0) {
        //       return `Please select at least one ${label.toLowerCase()}`;
        //     }
        //     return true;
        //   },
        // }}
        render={({ field, fieldState: { error } }) => {
          const selectedValues: any[] = field.value || [];
          const visibleValue = selectedValues[0];
          const isSingleOption = modifiedOptions.length === 1;
          const isSelected = selectedValues.length > 0;

          return (
            <div className="position-relative">
              <Select
                {...field}
                options={modifiedOptions}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                placeholder={placeholder}
                className={`react-select-container ${error ? "is-invalid" : ""}`}
                classNamePrefix="react-select"
                value={(field.value || [])
                  .map((v: any) => {
                    if (typeof v === "string" || typeof v === "number") {
                      return modifiedOptions.find((opt) => opt.value === v) || null;
                    }
                    return v;
                  })
                  .filter(Boolean)}
                getOptionLabel={(e: any) => e.label}
                getOptionValue={(e: any) => e.value}
                styles={customStyle(selectedValues)}
                menuIsOpen={undefined}
                isDisabled={isAllDisabled || (isSingleOption && isSelected)}
                onChange={(selected: any[] | null) => {
                  if (!selected || selected.length === 0) {
                    field.onChange(null);
                    return;
                  }

                  const isSelectAllSelected = selected.some(
                    (option) => option.value === "*"
                  );

                  if (isSelectAllSelected) {
                    field.onChange(modifiedOptions.slice(1));
                    document.activeElement instanceof HTMLElement &&
                      document.activeElement.blur();
                  } else if (
                    selected.length === allDataLength &&
                    field.value?.length !== allDataLength
                  ) {
                    field.onChange(modifiedOptions.slice(1));
                  } else {
                    field.onChange(selected);
                  }
                }}
              />

              {selectedValues.length > 2 && (
                <span
                  className="translate-middle-y end-0 me-3 badge rounded-pill bg-light text-primary border border-primary"
                  style={{
                    fontSize: "11px",
                    fontWeight: "500",
                    padding: "3px 6px",
                  }}
                >
                  +{selectedValues.length - 2} more
                </span>
              )}

              {error && (
                <span className="text-danger" style={{ fontSize: "0.8rem" }}>
                  {error.message}
                </span>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};

export default MultiSelectWithSelectAll;
